import React from 'react'; 
import PropTypes from 'prop-types'; 

import Button from '../../elements/Button';
import Image from '../../elements/Image'; 
import Point from '../../elements/Point'; 
import TestimonialSlider from '../../elements/TestimonialSlider'; 

import './style.scss'; 

function ProductTestimonials(props) {
  const { title, description, points, contentBucket, companies } = props; 
  let split_title = title.split("  "); 

  return (
    <div className="product-testimonials-container"> 
      <div className="text-panel row g-0">
        <div className="text-panel-upper col-lg-6 pe-lg-5">
          <h2 className="white-text">{title}</h2> 
          <p className="segment-text white-text">{description}</p> 
        </div>
        { points.map((point, i) => {
          return (
            <Point
              className="point col-md-6 col-lg-3" 
              image={point.image} 
              header={point.header} 
              text={point.text}
              button={point.button}
              option="transparent"
            />
          ); 
        })}
      </div>
    </div> 
  ); 
}

ProductTestimonials.propTypes = {
  title: PropTypes.string.isRequired, 
  description: PropTypes.string.isRequired, 
  points: PropTypes.array.isRequired, 
  contentBucket: PropTypes.string.isRequired, 
  companies: PropTypes.array.isRequired
}; 

export default ProductTestimonials; 
